import React from "react";
import { TSignedInWorkerState } from "../../../_model/repos/interfaces/IAuthRepo";

const HandymanCompanyRouteContext = React.createContext<TSignedInWorkerState>(
  {} as never
);

export default HandymanCompanyRouteContext;
